module.exports = __webpack_public_path__ + "static/media/product-2.5915dd8d.png";